const { sessionStorage } = window
export const Storage = sessionStorage
export const getSessionStorage = (key: string) => sessionStorage.getItem(key)
export const setSessionStorage = (key: string, value: string) => sessionStorage.setItem(key, value)
export const removeSessionStorage = (key: string) => sessionStorage.removeItem(key)
export const clearSessionStorage = () => sessionStorage.clear()
